import { useState, useMemo, useCallback, useEffect, useRef } from "react";
import { ChevronDown, Copy, RotateCcw, Check, Send, FileText, Clock, Percent, Tag } from "lucide-react";
import { toast } from "sonner";
import axios from "axios";
import "./AngebotsKalkulator.css";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const RATE = 195;

const POSITIONS = [
  // 01 PROZESSOPTIMIERUNG
  { cat: "01", catName: "Prozessoptimierung", code: "PO-01", name: "Erstgespräch & Briefing", desc: "Bedarfserhebung, Zieldefinition, Erwartungsabgleich", unit: "Pauschal", h: [1, 2, 3] },
  { cat: "01", code: "PO-02", name: "Prozessaufnahme & Interviews", desc: "Stakeholder-Interviews, Dokumentenanalyse, Beobachtung", unit: "Pauschal", h: [4, 8, 12] },
  { cat: "01", code: "PO-03", name: "Prozess-Mapping (Ist)", desc: "Visualisierung als BPMN / Swimlane-Diagramm", unit: "Pauschal", h: [4, 6, 10] },
  { cat: "01", code: "PO-04", name: "Analyse & Engpassidentifikation", desc: "Auswertung, Schwachstellen, Priorisierung nach Impact", unit: "Pauschal", h: [3, 4, 6] },
  { cat: "01", code: "PO-05", name: "Soll-Konzept & Prozess-Design", desc: "Neugestaltung optimierter Prozesse, Dokumentation", unit: "Pauschal", h: [5, 8, 12] },
  { cat: "01", code: "PO-06", name: "Massnahmenbericht", desc: "Schriftlicher Bericht, Empfehlungen, Zeitplan", unit: "Pauschal", h: [2, 4, 6] },
  { cat: "01", code: "PO-07", name: "Workshop-Moderation", desc: "Lean / Kaizen / Value Stream Mapping inkl. Protokoll", unit: "Pro Tag", h: [6, 8, 10], hasQty: true },
  { cat: "01", code: "PO-08", name: "Workflow-Automatisierung", desc: "Konzept & Umsetzung (Make, Zapier, Power Automate)", unit: "Pauschal", h: [6, 14, 24] },
  { cat: "01", code: "PO-09", name: "Change Management Begleitung", desc: "Kommunikation, Stakeholder, Schulungen", unit: "Pro Monat", h: [8, 12, 16], hasQty: true },

  // 02 DIGITALISIERUNG
  { cat: "02", catName: "Digitalisierung", code: "DI-01", name: "Discovery & Stakeholder-Interviews", desc: "Strukturierte Interviews, Bedarfsanalyse, Zieldefinition", unit: "Pauschal", h: [3, 5, 8] },
  { cat: "02", code: "DI-02", name: "Digitaler Reifegrad-Check", desc: "Bewertung Digitalisierungsgrad (People, Process, Tech)", unit: "Pauschal", h: [4, 6, 8] },
  { cat: "02", code: "DI-03", name: "Digitalstrategie-Entwicklung", desc: "Digitale Ziele, strategische Stossrichtung, Massnahmenfelder", unit: "Pauschal", h: [6, 10, 16] },
  { cat: "02", code: "DI-04", name: "Roadmap-Erstellung", desc: "Massnahmenplan mit Zeitachse, Abhängigkeiten, KPIs", unit: "Pauschal", h: [3, 5, 7] },
  { cat: "02", code: "DI-05", name: "Präsentation Entscheider", desc: "Aufbereitung und Präsentation, Executive Summary", unit: "Pauschal", h: [2, 4, 6] },
  { cat: "02", code: "DI-06", name: "Technologie-Evaluation", desc: "Marktanalyse und Bewertung Lösungen / Anbieter", unit: "Pauschal", h: [4, 6, 10] },
  { cat: "02", code: "DI-07", name: "System-Anforderungsanalyse", desc: "Erhebung funktionaler und nicht-funktionaler Anforderungen", unit: "Pauschal", h: [5, 8, 12] },
  { cat: "02", code: "DI-08", name: "Integrationskonzept & Architektur", desc: "Technisches Konzept Systemverbindung, Datenstrategie", unit: "Pauschal", h: [8, 12, 18] },
  { cat: "02", code: "DI-09", name: "Cloud-Migrationsplanung", desc: "Assessment, Strategie, Migrationsplan, Compliance-Check", unit: "Pauschal", h: [8, 14, 22] },
  { cat: "02", code: "DI-10", name: "Projektleitung / Steuerung", desc: "Koordination, Statusreporting, Stakeholder-Kommunikation", unit: "Pro Woche", h: [4, 6, 8], hasQty: true },

  // 03 KI & AUTOMATISIERUNG
  { cat: "03", catName: "KI & Automatisierung", code: "KI-01", name: "KI-Potenzial-Workshop", desc: "Identifikation von KI-Use-Cases, Bewertung, Priorisierung", unit: "Pauschal", h: [5, 7, 10] },
  { cat: "03", code: "KI-02", name: "Use-Case-Analyse & Business Case", desc: "Machbarkeit, Datenlage, ROI-Schätzung, Risiken", unit: "Pro Use Case", h: [2, 4, 6], hasQty: true },
  { cat: "03", code: "KI-03", name: "KI-Strategie & Roadmap", desc: "Governance, Dateninfrastruktur, Use Cases, Kompetenzaufbau", unit: "Pauschal", h: [8, 14, 20] },
  { cat: "03", code: "KI-04", name: "Chatbot-Konzept & Design", desc: "Anforderungen, Gesprächsfluss, Plattformwahl, Integration", unit: "Pauschal", h: [4, 6, 10] },
  { cat: "03", code: "KI-05", name: "Chatbot-Entwicklung & Training", desc: "Technische Umsetzung, Datenanbindung, Feintuning, QA", unit: "Pauschal", h: [14, 22, 32] },
  { cat: "03", code: "KI-06", name: "RPA-Prozessaufnahme", desc: "Analyse und Dokumentation Automatisierungskandidaten", unit: "Pauschal", h: [3, 5, 7] },
  { cat: "03", code: "KI-07", name: "RPA Bot-Entwicklung", desc: "Entwicklung und Deployment (UiPath / Power Automate)", unit: "Pro Bot", h: [10, 18, 26], hasQty: true },
  { cat: "03", code: "KI-08", name: "KI-Schulung Team", desc: "KI-Grundlagen, Prompt Engineering, Tool-Nutzung", unit: "Pro Tag", h: [6, 8, 10], hasQty: true },
  { cat: "03", code: "KI-09", name: "Proof of Concept (PoC)", desc: "Technischer Machbarkeitsnachweis auf Basis realer Daten", unit: "Pauschal", h: [10, 16, 22] },

  // 04 SOFTWARE ENTWICKLUNG
  { cat: "04", catName: "Software Entwicklung", code: "SW-01", name: "Requirements Engineering", desc: "User Stories, Akzeptanzkriterien, Dokumentation", unit: "Pauschal", h: [5, 9, 14] },
  { cat: "04", code: "SW-02", name: "UX-Konzept & Wireframes", desc: "IA, User Flows, Low-Fidelity Wireframes", unit: "Pauschal", h: [5, 9, 14] },
  { cat: "04", code: "SW-03", name: "UI-Design (Figma)", desc: "High-Fidelity Design, Design System, Responsive", unit: "Pauschal", h: [8, 16, 26] },
  { cat: "04", code: "SW-04", name: "Frontend-Entwicklung", desc: "React / Next.js / Vue, Responsive, performant", unit: "Pauschal", h: [14, 26, 44] },
  { cat: "04", code: "SW-05", name: "Backend-Entwicklung", desc: "Serverlogik, Datenmodell, Authentifizierung, DB", unit: "Pauschal", h: [14, 26, 44] },
  { cat: "04", code: "SW-06", name: "API-Entwicklung & Dokumentation", desc: "REST / GraphQL, Swagger / OpenAPI Dokumentation", unit: "Pauschal", h: [5, 10, 18] },
  { cat: "04", code: "SW-07", name: "Testing & QA", desc: "Funktionstests, Cross-Browser, Edge Cases, Bugfixing", unit: "Pauschal", h: [5, 9, 14] },
  { cat: "04", code: "SW-08", name: "Deployment & DevOps", desc: "Hosting, CI/CD-Pipeline, Domain/DNS, SSL, Monitoring", unit: "Pauschal", h: [3, 6, 12] },
  { cat: "04", code: "SW-09", name: "Technisches Audit", desc: "Performance, Security, Skalierbarkeit, Code-Qualität", unit: "Pauschal", h: [5, 9, 14] },
  { cat: "04", code: "SW-10", name: "Schulung & Übergabe", desc: "Einweisung, Dokumentation, Q&A-Session", unit: "Pauschal", h: [2, 3, 5] },
  { cat: "04", code: "SW-11", name: "Wartung & Support", desc: "Updates, Bugfixes, Hosting-Monitoring, Security", unit: "Pro Monat", h: [4, 6, 10], hasQty: true },

  // 05 WEB & DIGITAL MARKETING
  { cat: "05", catName: "Web & Digital Marketing", code: "WD-01", name: "Strategie & Konzept", desc: "Zielgruppen-Analyse, Message Hierarchy, Seitenstruktur", unit: "Pauschal", h: [3, 4, 6] },
  { cat: "05", code: "WD-02", name: "Copywriting", desc: "Headline, Subline, Body Copy, CTA-Texte", unit: "Pro Seite", h: [1, 3, 5], hasQty: true },
  { cat: "05", code: "WD-03", name: "UI-Design (Figma)", desc: "Visuelles Design, Desktop & Mobile Variante", unit: "Pro Seite", h: [3, 4, 6], hasQty: true },
  { cat: "05", code: "WD-04", name: "Entwicklung / Build", desc: "Technische Umsetzung, Responsive, CMS-Anbindung", unit: "Pro Seite", h: [3, 4, 7], hasQty: true },
  { cat: "05", code: "WD-05", name: "CMS-Setup & Konfiguration", desc: "Webflow / WordPress, Templates, Benutzerrollen", unit: "Pauschal", h: [3, 4, 6] },
  { cat: "05", code: "WD-06", name: "Tracking-Setup (GA4 + GTM)", desc: "Google Analytics 4, Tag Manager, Conversion-Events", unit: "Pauschal", h: [2, 4, 6] },
  { cat: "05", code: "WD-07", name: "CRM-Integration", desc: "Formular / Booking-Tool an CRM anbinden, Testing", unit: "Pauschal", h: [3, 4, 6] },
  { cat: "05", code: "WD-08", name: "SEO-Grundoptimierung", desc: "Title Tags, Meta, OpenGraph, Sitemap, Schema", unit: "Pauschal", h: [2, 3, 5] },
  { cat: "05", code: "WD-09", name: "CRO-Audit", desc: "Analytics, UX, Copy, Tech. Priorisierter Massnahmenbericht", unit: "Pauschal", h: [5, 8, 12] },
  { cat: "05", code: "WD-10", name: "QA & Cross-Browser-Test", desc: "Systematischer Test, Fehlerprotokoll, Fixes", unit: "Pauschal", h: [2, 3, 5] },
  { cat: "05", code: "WD-11", name: "Launch & Go-live Support", desc: "Domain, DNS, Post-launch Check, Monitoring 48h", unit: "Pauschal", h: [1, 2, 3] },
];

const COMPLEXITY_HINTS = {
  0: { label: "Klein", desc: "Einzelunternehmer / KMU < 20 MA, Budget < CHF 15k" },
  1: { label: "Standard", desc: "KMU 20\u2013200 MA, Budget CHF 15k\u201350k" },
  2: { label: "Komplex", desc: "Enterprise / > 200 MA, Budget > CHF 50k" },
};

function formatCHF(n) {
  const v = Number(n);
  if (isNaN(v) || !isFinite(v)) return "CHF \u2014";
  return "CHF " + Math.round(v).toLocaleString("de-CH").replace(/,/g, "\u2019");
}

function roundToNearest(n, step = 500) {
  return Math.ceil(n / step) * step;
}

function generateOfferNumber() {
  const now = new Date();
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, "0");
  const rand = Math.random().toString(36).substring(2, 5).toUpperCase();
  return `${y}-${m}-${rand}`;
}

function getTimelineSuggestion(totalH) {
  if (totalH <= 30) return { konzeption_weeks: 1, umsetzung_weeks: 2, review_weeks: 1 };
  if (totalH <= 60) return { konzeption_weeks: 2, umsetzung_weeks: 3, review_weeks: 1 };
  if (totalH <= 100) return { konzeption_weeks: 2, umsetzung_weeks: 4, review_weeks: 1 };
  if (totalH <= 160) return { konzeption_weeks: 2, umsetzung_weeks: 6, review_weeks: 2 };
  return { konzeption_weeks: 3, umsetzung_weeks: 8, review_weeks: 2 };
}

export default function AngebotsKalkulator() {
  const [complexity, setComplexity] = useState(1);
  const [selected, setSelected] = useState({});
  const [bufferPct, setBufferPct] = useState(20);
  const [clientName, setClientName] = useState("");
  const [projectName, setProjectName] = useState("");
  const [offerNumber, setOfferNumber] = useState(() => generateOfferNumber());
  const [ausgangslage, setAusgangslage] = useState("");
  const [atlasStatus, setAtlasStatus] = useState({ type: "", text: "" });
  const [collapsedCats, setCollapsedCats] = useState(new Set());
  const [sending, setSending] = useState(false);
  const [copied, setCopied] = useState(false);
  const [offers, setOffers] = useState([]);
  const [historyOpen, setHistoryOpen] = useState(false);
  const [discountType, setDiscountType] = useState("percent");
  const [discountValue, setDiscountValue] = useState(0);
  const [discountReason, setDiscountReason] = useState("");

  // Contact fields
  const [contacts, setContacts] = useState([]);
  const [selectedContactId, setSelectedContactId] = useState("");
  const [contactFirstName, setContactFirstName] = useState("");
  const [contactLastName, setContactLastName] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [startDate, setStartDate] = useState("");
  const [clientStreet, setClientStreet] = useState("");
  const [clientZip, setClientZip] = useState("");
  const [clientCity, setClientCity] = useState("");
  const [clientUid, setClientUid] = useState("");
  const [clientLegalForm, setClientLegalForm] = useState("");

  // Zefix autocomplete
  const [zefixResults, setZefixResults] = useState([]);
  const [zefixOpen, setZefixOpen] = useState(false);
  const [zefixLoading, setZefixLoading] = useState(false);
  const zefixTimer = useRef(null);
  const zefixWrapperRef = useRef(null);
  const zefixRequestId = useRef(0); // prevents stale responses from overwriting newer ones

  // Close dropdown when clicking outside the entire autocomplete area
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (zefixWrapperRef.current && !zefixWrapperRef.current.contains(e.target)) {
        setZefixOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Ref to always access latest discount values (avoids stale closure)
  const discountRef = useRef({ type: "percent", value: 0, reason: "" });
  useEffect(() => {
    discountRef.current = { type: discountType, value: discountValue, reason: discountReason };
  }, [discountType, discountValue, discountReason]);

  const loadOffers = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/admin/kalkulator/offers`);
      setOffers(res.data);
    } catch {}
  }, []);

  const loadContacts = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/admin/contacts`);
      setContacts(res.data);
    } catch {}
  }, []);

  useEffect(() => { loadOffers(); loadContacts(); }, [loadOffers, loadContacts]);

  const handleContactSelect = useCallback((contactId) => {
    setSelectedContactId(contactId);
    if (!contactId) {
      setClientName(""); setContactFirstName(""); setContactLastName(""); setContactEmail("");
      return;
    }
    const c = contacts.find((ct) => ct.id === contactId);
    if (c) {
      setClientName(c.company || c.first_name ? `${c.first_name || ''} ${c.last_name || ''}`.trim() : c.name || "");
      const nameParts = (c.first_name || c.name || "").split(" ");
      setContactFirstName(c.first_name || nameParts[0] || "");
      setContactLastName(c.last_name || nameParts.slice(1).join(" ") || "");
      setContactEmail(c.email || "");
    }
  }, [contacts]);

  // Zefix debounced search with stale-response protection
  const searchZefix = useCallback((q) => {
    setClientName(q);
    if (zefixTimer.current) clearTimeout(zefixTimer.current);
    if (q.length < 2) { setZefixResults([]); setZefixOpen(false); setZefixLoading(false); return; }
    setZefixLoading(true);
    const myRequestId = ++zefixRequestId.current;
    zefixTimer.current = setTimeout(async () => {
      try {
        const res = await axios.get(`${API}/admin/zefix/search`, { params: { q } });
        // Only apply results if this is still the latest request
        if (myRequestId === zefixRequestId.current) {
          setZefixResults(res.data);
          setZefixOpen(res.data.length > 0);
          setZefixLoading(false);
        }
      } catch {
        if (myRequestId === zefixRequestId.current) {
          setZefixLoading(false);
        }
      }
    }, 500);
  }, []);

  const selectZefix = useCallback((company) => {
    setClientName(company.name);
    setClientStreet(company.street || "");
    setClientZip(company.zip || "");
    setClientCity(company.locality || "");
    setClientUid(company.uid || "");
    setClientLegalForm(company.legalForm || "");
    setZefixOpen(false);
    setZefixResults([]);
  }, []);

  // Load a past offer back into the calculator
  const loadOffer = useCallback((offer) => {
    const p = offer.payload;
    if (!p) { toast.error("Keine Details für dieses Angebot verfügbar."); return; }

    // Client details
    setClientName(p.client?.name || "");
    setProjectName(p.client?.project_name || "");
    setContactFirstName(p.client?.first_name || p.client?.contact_person?.split(" ")[0] || "");
    setContactLastName(p.client?.last_name || p.client?.contact_person?.split(" ").slice(1).join(" ") || "");
    setContactEmail(p.client?.email || "");
    setSelectedContactId(p.client?.contact_id || "");
    setClientStreet(p.client?.street || "");
    setClientZip(p.client?.zip || "");
    setClientCity(p.client?.city || "");
    setClientUid(p.client?.uid || "");
    setClientLegalForm(p.client?.legal_form || "");
    setOfferNumber(p.offer?.number || generateOfferNumber());
    setAusgangslage(p.project?.ausgangslage || "");
    setStartDate(p.project?.start_date || "");

    // Complexity
    const cMap = { "Klein": 0, "Standard": 1, "Komplex": 2 };
    setComplexity(cMap[p.project?.complexity] ?? 1);

    // Buffer
    setBufferPct(p.calculation?.buffer_percent ?? 20);

    // Positions
    const sel = {};
    (p.positions || []).forEach((pos) => { sel[pos.code] = pos.qty || 1; });
    setSelected(sel);

    // Discount
    const disc = p.calculation?.discount;
    if (disc && disc.value > 0) {
      setDiscountType(disc.type || "percent");
      setDiscountValue(disc.value);
      setDiscountReason(disc.reason || "");
    } else {
      setDiscountType("percent");
      setDiscountValue(0);
      setDiscountReason("");
    }

    setAtlasStatus({ type: "", text: "" });
    toast.success(`Angebot ${p.offer?.number || ""} geladen`);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  // Group positions by category
  const categories = useMemo(() => {
    const cats = [];
    const catMap = {};
    POSITIONS.forEach((p) => {
      if (!catMap[p.cat]) {
        catMap[p.cat] = { id: p.cat, name: p.catName || p.cat, positions: [] };
        cats.push(catMap[p.cat]);
      }
      catMap[p.cat].positions.push(p);
    });
    return cats;
  }, []);

  // Calculations
  const getH = useCallback((pos) => pos.h[complexity], [complexity]);

  const totalH = useMemo(() => {
    let h = 0;
    POSITIONS.forEach((p) => {
      if (p.code in selected) h += p.h[complexity] * (selected[p.code] || 1);
    });
    return h;
  }, [selected, complexity]);

  const subtotal = totalH * RATE;
  const bufferAmt = Math.round((subtotal * bufferPct) / 100);
  const preRound = subtotal + bufferAmt;
  const fixpreis = totalH === 0 ? 0 : roundToNearest(preRound, 500);
  const discountAmt = fixpreis === 0 ? 0 : discountType === "percent"
    ? Math.round((fixpreis * discountValue) / 100)
    : Math.min(discountValue, fixpreis);
  const endpreis = Math.max(0, fixpreis - discountAmt);
  const hasDiscount = discountValue > 0 && fixpreis > 0;
  const totalDays = (totalH / 8).toFixed(1);
  const posCount = Object.keys(selected).length;

  // Count per category
  const catCounts = useMemo(() => {
    const counts = {};
    POSITIONS.forEach((p) => {
      if (!counts[p.cat]) counts[p.cat] = 0;
      if (p.code in selected) counts[p.cat]++;
    });
    return counts;
  }, [selected]);

  const togglePos = useCallback((code, checked) => {
    setSelected((prev) => {
      if (checked) return { ...prev, [code]: prev[code] || 1 };
      const next = { ...prev };
      delete next[code];
      return next;
    });
  }, []);

  const updateQty = useCallback((code, val) => {
    const n = Math.max(1, parseInt(val) || 1);
    setSelected((prev) => ({ ...prev, [code]: n }));
  }, []);

  const toggleCat = useCallback((catId) => {
    setCollapsedCats((prev) => {
      const next = new Set(prev);
      if (next.has(catId)) next.delete(catId);
      else next.add(catId);
      return next;
    });
  }, []);

  const resetAll = useCallback(() => {
    setSelected({});
    setClientName("");
    setProjectName("");
    setOfferNumber(generateOfferNumber());
    setAusgangslage("");
    setAtlasStatus({ type: "", text: "" });
    setBufferPct(20);
    setDiscountType("percent");
    setDiscountValue(0);
    setDiscountReason("");
    setSelectedContactId("");
    setContactFirstName("");
    setContactLastName("");
    setContactEmail("");
    setStartDate("");
    toast.info("Kalkulator zurückgesetzt");
  }, []);

  const copyResult = useCallback(async () => {
    const items = Object.keys(selected);
    if (items.length === 0) {
      toast.warning("Keine Positionen gewählt.");
      return;
    }

    const lines = ["LAB336 \u2013 Angebotskalkulation", "================================", ""];
    if (clientName) lines.push(`Kunde: ${clientName}`);
    if (contactFirstName || contactLastName) lines.push(`Ansprechpartner: ${contactFirstName} ${contactLastName}`.trim());
    if (contactEmail) lines.push(`E-Mail: ${contactEmail}`);
    if (projectName) lines.push(`Projekt: ${projectName}`);
    if (offerNumber) lines.push(`Angebots-Nr.: ${offerNumber}`);
    if (startDate) lines.push(`Startdatum: ${new Date(startDate).toLocaleDateString("de-CH")}`);
    if (clientName || projectName || offerNumber) lines.push("");

    items.forEach((code) => {
      const pos = POSITIONS.find((p) => p.code === code);
      if (!pos) return;
      const qty = selected[code] || 1;
      const h = pos.h[complexity] * qty;
      const chf = h * RATE;
      const qtyStr = pos.hasQty ? ` (${qty}\u00d7 ${pos.unit})` : "";
      lines.push(`${pos.code}  ${pos.name}${qtyStr}`);
      lines.push(`       ${h} h \u2192 CHF ${chf.toLocaleString("de-CH")}`);
    });

    lines.push("");
    lines.push("--------------------------------");
    lines.push(`Stunden total:   ${totalH} h`);
    lines.push(`Subtotal:        ${formatCHF(subtotal)}`);
    lines.push(`Scope-Puffer:    ${bufferPct}%`);
    lines.push(`Fixpreis:        ${formatCHF(fixpreis)} (exkl. MwSt.)`);
    if (hasDiscount) {
      const discLabel = discountType === "percent" ? `${discountValue}%` : formatCHF(discountValue);
      lines.push(`Rabatt:          ${discLabel}${discountReason ? ` (${discountReason})` : ""} = −${formatCHF(discountAmt)}`);
      lines.push(`Endpreis:        ${formatCHF(endpreis)} (exkl. MwSt.)`);
    }

    try {
      await navigator.clipboard.writeText(lines.join("\n"));
      setCopied(true);
      toast.success("Kalkulation kopiert!");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("Kopieren fehlgeschlagen");
    }
  }, [selected, complexity, totalH, subtotal, bufferPct, fixpreis, hasDiscount, discountType, discountValue, discountReason, discountAmt, endpreis, clientName, projectName, offerNumber]);

  const sendToAtlas = useCallback(async () => {
    if (!clientName) {
      setAtlasStatus({ type: "err", text: "Bitte Kundenname eingeben (Schritt 1 oben)" });
      return;
    }
    if (Object.keys(selected).length === 0) {
      setAtlasStatus({ type: "err", text: "Keine Positionen ausgewählt" });
      return;
    }

    const positions = [];
    let calcTotalH = 0;
    POSITIONS.forEach((p) => {
      if (!(p.code in selected)) return;
      const qty = selected[p.code] || 1;
      const h = p.h[complexity] * qty;
      const amount = h * RATE;
      calcTotalH += h;
      positions.push({
        code: p.code, name: p.name, description: p.desc,
        unit: p.unit, qty, hours: h, amount_chf: amount,
      });
    });

    const calcSubtotal = calcTotalH * RATE;
    const calcBufAmt = Math.round((calcSubtotal * bufferPct) / 100);
    const calcPreRound = calcSubtotal + calcBufAmt;
    const calcFixpreis = calcTotalH === 0 ? 0 : roundToNearest(calcPreRound, 500);

    // Read latest discount values from ref (avoids stale closure)
    const disc = discountRef.current;
    const calcDiscountAmt = calcFixpreis === 0 || disc.value <= 0 ? 0 : disc.type === "percent"
      ? Math.round((calcFixpreis * disc.value) / 100)
      : Math.min(disc.value, calcFixpreis);
    const calcEndpreis = Math.max(0, calcFixpreis - calcDiscountAmt);

    const complexityLabels = { 0: "Klein", 1: "Standard", 2: "Komplex" };
    const complexityDescs = {
      0: "Einzelunternehmer / KMU < 20 MA, Budget < CHF 15k",
      1: "KMU 20\u2013200 MA, Budget CHF 15k\u201350k",
      2: "Enterprise / > 200 MA, Budget > CHF 50k",
    };

    const fmtDate = (d) =>
      `${String(d.getDate()).padStart(2, "0")}.${String(d.getMonth() + 1).padStart(2, "0")}.${d.getFullYear()}`;
    const today = new Date();
    const validUntil = new Date(today);
    validUntil.setDate(validUntil.getDate() + 30);

    const finalOfferNumber = offerNumber || generateOfferNumber();
    if (!offerNumber) setOfferNumber(finalOfferNumber);

    const payload = {
      event: "offer_calculated",
      offer: { number: finalOfferNumber, date: fmtDate(today), valid_until: fmtDate(validUntil) },
      client: {
        contact_id: selectedContactId || null,
        name: clientName,
        first_name: contactFirstName,
        last_name: contactLastName,
        contact_person: `${contactFirstName} ${contactLastName}`.trim(),
        email: contactEmail,
        project_name: projectName || clientName,
        street: clientStreet || null,
        zip: clientZip || null,
        city: clientCity || null,
        uid: clientUid || null,
        legal_form: clientLegalForm || null,
      },
      project: {
        ausgangslage,
        start_date: startDate || null,
        complexity: complexityLabels[complexity],
        complexity_description: complexityDescs[complexity],
      },
      positions,
      calculation: {
        total_hours: calcTotalH,
        total_days: Math.round((calcTotalH / 8) * 10) / 10,
        rate_chf: RATE,
        subtotal_chf: calcSubtotal,
        buffer_percent: bufferPct,
        buffer_amount_chf: calcBufAmt,
        pre_round_chf: Math.round(calcPreRound),
        fixpreis_chf: calcFixpreis,
        discount: disc.value > 0 ? {
          type: disc.type,
          value: disc.value,
          reason: disc.reason || null,
          amount_chf: calcDiscountAmt,
        } : null,
        endpreis_chf: disc.value > 0 ? calcEndpreis : calcFixpreis,
      },
      timeline: getTimelineSuggestion(calcTotalH),
    };

    setSending(true);
    setAtlasStatus({ type: "loading", text: "Sende an Atlas OS\u2026" });

    try {
      const res = await axios.post(`${API}/admin/kalkulator/send`, payload);
      if (res.data.status === "success") {
        setAtlasStatus({ type: "ok", text: `Angebot ${finalOfferNumber} an Atlas OS übermittelt` });
        toast.success("Angebot erfolgreich übermittelt!");
        loadOffers();
      } else {
        setAtlasStatus({ type: "err", text: `Atlas OS antwortete mit Status ${res.data.status_code}` });
        toast.error(`Atlas OS Fehler: Status ${res.data.status_code}`);
      }
    } catch (err) {
      const msg = err.response?.data?.detail || err.message;
      setAtlasStatus({ type: "err", text: `Fehler: ${msg}` });
      toast.error(`Atlas OS Fehler: ${msg}`);
    } finally {
      setSending(false);
    }
  }, [selected, complexity, bufferPct, clientName, projectName, offerNumber, ausgangslage]);

  return (
    <div className="kalk-root" data-testid="kalkulator-root">
      {/* Rate & Complexity Bar */}
      <div className="kalk-rate-bar" data-testid="kalkulator-complexity-bar">
        <div className="kalk-rate-display">
          Stundensatz <span>CHF {RATE}</span> / h &nbsp;&middot;&nbsp; intern
        </div>
        <span className="kalk-complexity-label">Projektkomplexität:</span>
        <div className="kalk-complexity-options">
          {[
            { level: 0, label: "Klein" },
            { level: 1, label: "Standard" },
            { level: 2, label: "Komplex" },
          ].map((c) => (
            <button
              key={c.level}
              className={`kalk-complexity-btn ${complexity === c.level ? "active" : ""}`}
              onClick={() => setComplexity(c.level)}
              data-testid={`kalkulator-complexity-${c.label.toLowerCase()}`}
            >
              {c.label}
            </button>
          ))}
        </div>
        <span className="kalk-complexity-hint">
          <span>{COMPLEXITY_HINTS[complexity].label}</span> = {COMPLEXITY_HINTS[complexity].desc}
        </span>
      </div>

      {/* Client Details */}
      <div className="kalk-client-section" data-testid="kalkulator-client-section">
        <div className="kalk-client-header">
          <span className="kalk-client-badge">Schritt 1</span>
          <span className="kalk-client-title">Kundendetails — für Angebotserstellung via Atlas OS</span>
        </div>
        <div className="kalk-client-fields">
          <div className="kalk-client-field" style={{ gridColumn: "1 / -1" }}>
            <label htmlFor="kalk-contact">Kontakt wählen</label>
            <select
              id="kalk-contact"
              className="kalk-client-input kalk-client-select"
              value={selectedContactId}
              onChange={(e) => handleContactSelect(e.target.value)}
              data-testid="kalkulator-contact-select"
            >
              <option value="">— Kontakt wählen oder manuell eingeben —</option>
              {contacts.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.company || c.name} — {c.name} ({c.email})
                </option>
              ))}
            </select>
          </div>
          <div className="kalk-client-field" style={{ position: "relative" }} ref={zefixWrapperRef}>
            <label htmlFor="kalk-clientName">Firma / Kundenname * <span className="kalk-zefix-badge">Zefix</span></label>
            <input
              type="text"
              id="kalk-clientName"
              className="kalk-client-input"
              placeholder="Tippen für Handelsregister-Suche..."
              value={clientName}
              onChange={(e) => searchZefix(e.target.value)}
              onFocus={() => { if (zefixResults.length > 0) setZefixOpen(true); }}
              autoComplete="off"
              data-testid="kalkulator-client-name"
            />
            {zefixLoading && (
              <div className="kalk-zefix-loading" data-testid="kalkulator-zefix-loading">
                <span className="kalk-zefix-spinner"></span> Handelsregister wird durchsucht...
              </div>
            )}
            {zefixOpen && zefixResults.length > 0 && (
              <div
                className="kalk-zefix-dropdown"
                data-testid="kalkulator-zefix-dropdown"
              >
                {zefixResults.map((r, i) => (
                  <div
                    key={i}
                    className="kalk-zefix-item"
                    onMouseDown={() => selectZefix(r)}
                    data-testid={`kalkulator-zefix-${i}`}
                  >
                    <div className="kalk-zefix-main">
                      <span className="kalk-zefix-name">{r.name}</span>
                      {r.legalForm && <span className="kalk-zefix-legalform">{r.legalForm}</span>}
                    </div>
                    <div className="kalk-zefix-meta">
                      {(r.zip || r.locality) && (
                        <span className="kalk-zefix-address">{[r.zip, r.locality].filter(Boolean).join(" ")}</span>
                      )}
                      {r.uid && <span className="kalk-zefix-uid">{r.uid}</span>}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
          {/* Zefix auto-filled address row */}
          {(clientStreet || clientZip || clientCity || clientUid) && (
            <div className="kalk-address-row" data-testid="kalkulator-address-row">
              <div className="kalk-client-field kalk-field-street">
                <label htmlFor="kalk-street">Strasse</label>
                <input type="text" id="kalk-street" className="kalk-client-input" value={clientStreet} onChange={(e) => setClientStreet(e.target.value)} data-testid="kalkulator-street" />
              </div>
              <div className="kalk-client-field kalk-field-zip">
                <label htmlFor="kalk-zip">PLZ</label>
                <input type="text" id="kalk-zip" className="kalk-client-input" value={clientZip} onChange={(e) => setClientZip(e.target.value)} data-testid="kalkulator-zip" />
              </div>
              <div className="kalk-client-field kalk-field-city">
                <label htmlFor="kalk-city">Ort</label>
                <input type="text" id="kalk-city" className="kalk-client-input" value={clientCity} onChange={(e) => setClientCity(e.target.value)} data-testid="kalkulator-city" />
              </div>
              <div className="kalk-client-field kalk-field-uid">
                <label htmlFor="kalk-uid">UID</label>
                <input type="text" id="kalk-uid" className="kalk-client-input" value={clientUid} readOnly data-testid="kalkulator-uid" />
              </div>
            </div>
          )}
          <div className="kalk-client-field">
            <label htmlFor="kalk-firstName">Vorname</label>
            <input
              type="text"
              id="kalk-firstName"
              className="kalk-client-input"
              placeholder="Max"
              value={contactFirstName}
              onChange={(e) => setContactFirstName(e.target.value)}
              data-testid="kalkulator-first-name"
            />
          </div>
          <div className="kalk-client-field">
            <label htmlFor="kalk-lastName">Nachname</label>
            <input
              type="text"
              id="kalk-lastName"
              className="kalk-client-input"
              placeholder="Mustermann"
              value={contactLastName}
              onChange={(e) => setContactLastName(e.target.value)}
              data-testid="kalkulator-last-name"
            />
          </div>
          <div className="kalk-client-field">
            <label htmlFor="kalk-contactEmail">E-Mail</label>
            <input
              type="email"
              id="kalk-contactEmail"
              className="kalk-client-input"
              placeholder="z.B. max@firma.ch"
              value={contactEmail}
              onChange={(e) => setContactEmail(e.target.value)}
              data-testid="kalkulator-contact-email"
            />
          </div>
          <div className="kalk-client-field">
            <label htmlFor="kalk-projectName">Projektname</label>
            <input
              type="text"
              id="kalk-projectName"
              className="kalk-client-input"
              placeholder="z.B. Corporate Website Relaunch"
              value={projectName}
              onChange={(e) => setProjectName(e.target.value)}
              data-testid="kalkulator-project-name"
            />
          </div>
          <div className="kalk-client-field">
            <label htmlFor="kalk-offerNumber">Angebots-Nr.</label>
            <input
              type="text"
              id="kalk-offerNumber"
              className="kalk-client-input"
              placeholder="Auto"
              value={offerNumber}
              onChange={(e) => setOfferNumber(e.target.value)}
              data-testid="kalkulator-offer-number"
            />
          </div>
          <div className="kalk-client-field">
            <label htmlFor="kalk-startDate">Startdatum</label>
            <input
              type="date"
              id="kalk-startDate"
              className="kalk-client-input"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              data-testid="kalkulator-start-date"
            />
          </div>
          <div className="kalk-client-field kalk-client-field-full">
            <label htmlFor="kalk-ausgangslage">
              Ausgangslage (Atlas OS generiert daraus den Einleitungstext)
            </label>
            <textarea
              id="kalk-ausgangslage"
              className="kalk-client-input kalk-client-textarea"
              placeholder="Kurze Beschreibung der Situation, Ziele und Hintergrund"
              value={ausgangslage}
              onChange={(e) => setAusgangslage(e.target.value)}
              data-testid="kalkulator-ausgangslage"
            />
          </div>
        </div>
      </div>

      {/* Main Layout */}
      <div className="kalk-layout">
        {/* Left: Positions */}
        <div className="kalk-positions" data-testid="kalkulator-positions">
          {categories.map((cat) => {
            const isCollapsed = collapsedCats.has(cat.id);
            const count = catCounts[cat.id] || 0;
            return (
              <div key={cat.id} className="kalk-cat-block">
                <div
                  className="kalk-cat-header"
                  onClick={() => toggleCat(cat.id)}
                  data-testid={`kalkulator-cat-${cat.id}`}
                >
                  <span className="kalk-cat-badge">{cat.id.padStart(2, "0")}</span>
                  <span className="kalk-cat-title">{cat.name}</span>
                  <span className="kalk-cat-count">{count > 0 ? `${count} gewählt` : ""}</span>
                  <span className={`kalk-cat-toggle ${isCollapsed ? "collapsed" : ""}`}>
                    <ChevronDown className="w-4 h-4" />
                  </span>
                </div>
                {!isCollapsed && (
                  <div className="kalk-cat-positions">
                    {cat.positions.map((pos) => {
                      const isSelected = pos.code in selected;
                      const qty = selected[pos.code] || 1;
                      const h = getH(pos) * qty;
                      const chf = h * RATE;

                      return (
                        <div
                          key={pos.code}
                          className={`kalk-pos-row ${isSelected ? "selected" : ""}`}
                          data-testid={`kalkulator-pos-${pos.code}`}
                        >
                          <input
                            type="checkbox"
                            className="kalk-pos-check"
                            checked={isSelected}
                            onChange={(e) => togglePos(pos.code, e.target.checked)}
                            data-testid={`kalkulator-chk-${pos.code}`}
                          />
                          <div className="kalk-pos-info">
                            <div className="kalk-pos-name">
                              <span className="kalk-pos-code">{pos.code}</span>
                              {pos.name}
                              {pos.hasQty && <span className="kalk-pos-unit-badge">{pos.unit}</span>}
                            </div>
                            <div className="kalk-pos-desc">{pos.desc}</div>
                          </div>
                          <div className={`kalk-pos-qty-wrap ${isSelected && pos.hasQty ? "active" : ""}`}>
                            <span className="kalk-pos-qty-label">{pos.unit}:</span>
                            <input
                              type="number"
                              className="kalk-pos-qty-input"
                              min="1"
                              max="99"
                              value={qty}
                              onChange={(e) => updateQty(pos.code, e.target.value)}
                              onClick={(e) => e.stopPropagation()}
                              data-testid={`kalkulator-qty-${pos.code}`}
                            />
                          </div>
                          <div className={`kalk-pos-price ${isSelected ? "active" : ""}`}>
                            <div className="kalk-pos-price-chf">
                              {isSelected ? formatCHF(chf) : "\u2014"}
                            </div>
                            <div className="kalk-pos-hours">
                              {isSelected ? `${h} h` : "\u2014 h"}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* Right: Summary Panel */}
        <div className="kalk-summary" data-testid="kalkulator-summary">
          <div className="kalk-summary-title">Kalkulation</div>

          {/* Selected Items */}
          <div className="kalk-selected-list">
            {posCount === 0 ? (
              <div className="kalk-selected-empty">Noch keine Positionen gewählt.</div>
            ) : (
              Object.keys(selected).map((code) => {
                const pos = POSITIONS.find((p) => p.code === code);
                if (!pos) return null;
                const qty = selected[code] || 1;
                const h = getH(pos) * qty;
                const chf = h * RATE;
                const qtyStr = pos.hasQty ? ` \u00d7 ${qty} ${pos.unit}` : "";
                return (
                  <div key={code} className="kalk-selected-item">
                    <div>
                      <div className="kalk-si-code">{pos.code}</div>
                      <div className="kalk-si-name">{pos.name}</div>
                      <div className="kalk-si-detail">{h}h{qtyStr}</div>
                    </div>
                    <div className="kalk-si-price">{formatCHF(chf)}</div>
                  </div>
                );
              })
            )}
          </div>

          {/* Bottom section */}
          <div>
            {/* Hours summary */}
            <div className="kalk-hours-summary">
              <div className="kalk-hs-item">
                <div className="kalk-hs-value" data-testid="kalkulator-total-hours">{totalH}</div>
                <div className="kalk-hs-label">Stunden</div>
              </div>
              <div className="kalk-hs-item">
                <div className="kalk-hs-value" data-testid="kalkulator-total-days">{totalDays}</div>
                <div className="kalk-hs-label">Tage (à 8h)</div>
              </div>
              <div className="kalk-hs-item">
                <div className="kalk-hs-value" data-testid="kalkulator-total-positions">{posCount}</div>
                <div className="kalk-hs-label">Positionen</div>
              </div>
            </div>

            {/* Calc block */}
            <div className="kalk-calc-block">
              <div className="kalk-calc-row">
                <span className="kalk-calc-label">Summe (CHF {RATE}/h)</span>
                <span className="kalk-calc-value" data-testid="kalkulator-subtotal">{formatCHF(subtotal)}</span>
              </div>

              {/* Buffer control */}
              <div className="kalk-buffer-control">
                <div className="kalk-buffer-top">
                  <span className="kalk-buffer-label">Scope-Puffer</span>
                  <span className="kalk-buffer-value" data-testid="kalkulator-buffer-pct">{bufferPct}%</span>
                </div>
                <input
                  type="range"
                  className="kalk-buffer-slider"
                  min="0"
                  max="40"
                  step="5"
                  value={bufferPct}
                  onChange={(e) => setBufferPct(parseInt(e.target.value))}
                  data-testid="kalkulator-buffer-slider"
                />
                <div className="kalk-buffer-amounts">
                  <span className="kalk-buffer-pct">0%</span>
                  <span className="kalk-buffer-pct">10%</span>
                  <span className="kalk-buffer-pct">20%</span>
                  <span className="kalk-buffer-pct">30%</span>
                  <span className="kalk-buffer-pct">40%</span>
                </div>
              </div>

              <div className="kalk-calc-row">
                <span className="kalk-calc-label">Puffer-Betrag</span>
                <span className="kalk-calc-value">{formatCHF(bufferAmt)}</span>
              </div>
              <div className="kalk-calc-row" style={{ marginBottom: "0.875rem" }}>
                <span className="kalk-calc-label">Vor Rundung</span>
                <span className="kalk-calc-value">{formatCHF(preRound)}</span>
              </div>
            </div>

            {/* Total box */}
            <div className="kalk-total-box" data-testid="kalkulator-total-box">
              <div className="kalk-total-label">Fixpreis Angebot (gerundet)</div>
              <div className="kalk-total-value" data-testid="kalkulator-fixpreis">
                {totalH === 0 ? "CHF 0" : formatCHF(fixpreis)}
              </div>
              <div className="kalk-total-sub">
                {totalH} h × CHF {RATE} + {bufferPct}% Puffer, exkl. MwSt.
              </div>
            </div>

            {/* Discount control */}
            <div className="kalk-discount-control" data-testid="kalkulator-discount">
              <div className="kalk-discount-top">
                <span className="kalk-discount-label">
                  <Tag className="w-3 h-3 inline-block mr-1 -mt-0.5" />
                  Rabatt
                </span>
                <div className="kalk-discount-type-toggle">
                  <button
                    className={`kalk-discount-type-btn ${discountType === "percent" ? "active" : ""}`}
                    onClick={() => { setDiscountType("percent"); setDiscountValue(0); }}
                    data-testid="kalkulator-discount-type-percent"
                  >
                    <Percent className="w-3 h-3" />
                  </button>
                  <button
                    className={`kalk-discount-type-btn ${discountType === "fixed" ? "active" : ""}`}
                    onClick={() => { setDiscountType("fixed"); setDiscountValue(0); }}
                    data-testid="kalkulator-discount-type-fixed"
                  >
                    CHF
                  </button>
                </div>
              </div>
              <div className="kalk-discount-input-row">
                <input
                  type="number"
                  className="kalk-discount-input"
                  min="0"
                  max={discountType === "percent" ? 100 : fixpreis}
                  value={discountValue || ""}
                  placeholder="0"
                  onChange={(e) => setDiscountValue(Math.max(0, parseFloat(e.target.value) || 0))}
                  data-testid="kalkulator-discount-value"
                />
                <span className="kalk-discount-unit">{discountType === "percent" ? "%" : "CHF"}</span>
                {hasDiscount && <span className="kalk-discount-amount">= −{formatCHF(discountAmt)}</span>}
              </div>
              <input
                type="text"
                className="kalk-discount-reason"
                placeholder="Grund (z.B. Partnerrabatt, Erstauftrag)"
                value={discountReason}
                onChange={(e) => setDiscountReason(e.target.value)}
                data-testid="kalkulator-discount-reason"
              />
            </div>

            {/* Endpreis box (only when discount active) */}
            {hasDiscount && (
              <div className="kalk-endpreis-box" data-testid="kalkulator-endpreis-box">
                <div className="kalk-endpreis-label">Endpreis nach Rabatt</div>
                <div className="kalk-endpreis-value" data-testid="kalkulator-endpreis">
                  {formatCHF(endpreis)}
                </div>
                <div className="kalk-endpreis-sub">
                  {formatCHF(fixpreis)} − {discountType === "percent" ? `${discountValue}%` : formatCHF(discountValue)}
                  {discountReason ? ` (${discountReason})` : ""}, exkl. MwSt.
                </div>
              </div>
            )}

            {/* Action buttons */}
            <div style={{ marginTop: "0.75rem", display: "flex", flexDirection: "column", gap: "0.5rem" }}>
              <button
                className="kalk-atlas-btn"
                onClick={sendToAtlas}
                disabled={sending}
                data-testid="kalkulator-atlas-btn"
              >
                <Send className="w-3.5 h-3.5 inline-block mr-1.5 -mt-0.5" />
                {sending ? "Sende..." : "Angebot erstellen → Atlas OS"}
              </button>
              <div className={`kalk-atlas-status ${atlasStatus.type}`} data-testid="kalkulator-atlas-status">
                {atlasStatus.text}
              </div>
              <button
                className="kalk-copy-btn"
                onClick={copyResult}
                data-testid="kalkulator-copy-btn"
              >
                {copied ? (
                  <><Check className="w-3.5 h-3.5 inline-block mr-1.5 -mt-0.5" /> Kopiert!</>
                ) : (
                  <><Copy className="w-3.5 h-3.5 inline-block mr-1.5 -mt-0.5" /> Kalkulation kopieren (intern)</>
                )}
              </button>
              <button
                className="kalk-reset-btn"
                onClick={resetAll}
                data-testid="kalkulator-reset-btn"
              >
                <RotateCcw className="w-3 h-3 inline-block mr-1 -mt-0.5" />
                Alles zurücksetzen
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Offers History */}
      {offers.length > 0 && (
        <div className="kalk-history" data-testid="kalkulator-history">
          <div
            className="kalk-history-header"
            onClick={() => setHistoryOpen((v) => !v)}
            data-testid="kalkulator-history-toggle"
          >
            <FileText className="w-4 h-4" />
            <span>Angebotshistorie ({offers.length})</span>
            <ChevronDown className={`w-4 h-4 kalk-history-chevron ${historyOpen ? "" : "collapsed"}`} />
          </div>
          {historyOpen && (
            <div className="kalk-history-table">
              <div className="kalk-history-row kalk-history-head">
                <span>Nr.</span>
                <span>Kunde</span>
                <span>Projekt</span>
                <span>Komplexität</span>
                <span>Pos.</span>
                <span>Stunden</span>
                <span>Fixpreis</span>
                <span>Endpreis</span>
                <span>Atlas</span>
                <span>Datum</span>
              </div>
              {offers.map((o, i) => (
                <div
                  key={i}
                  className="kalk-history-row kalk-history-clickable"
                  onClick={() => loadOffer(o)}
                  title="Klicken, um Angebot in den Kalkulator zu laden"
                  data-testid={`kalkulator-offer-row-${i}`}
                >
                  <span className="kalk-h-nr">{o.offer_number}</span>
                  <span className="kalk-h-client">{o.client_name}</span>
                  <span className="kalk-h-project">{o.project_name || "\u2014"}</span>
                  <span className="kalk-h-complexity">{o.complexity}</span>
                  <span>{o.positions_count}</span>
                  <span>{o.total_hours}h</span>
                  <span className="kalk-h-price">{formatCHF(o.fixpreis_chf)}</span>
                  <span className="kalk-h-endpreis">
                    {o.discount ? (
                      <>{formatCHF(o.endpreis_chf)} <span className="kalk-h-discount-tag">{o.discount.type === "percent" ? `−${o.discount.value}%` : `−${formatCHF(o.discount.value)}`}</span></>
                    ) : "\u2014"}
                  </span>
                  <span className={o.atlas_sent ? "kalk-h-ok" : "kalk-h-err"}>{o.atlas_sent ? "Gesendet" : "Fehler"}</span>
                  <span className="kalk-h-date">
                    <Clock className="w-3 h-3 inline-block mr-1 -mt-0.5 opacity-40" />
                    {o.created_at ? new Date(o.created_at).toLocaleDateString("de-CH", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "\u2014"}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
